import {
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";
import { IconAlertTriangle, IconTrash } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { deleteFormula, formulaDeleteErrorClear } from "store/app/report-management/reports/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
//import Chip from "ui-component/extended/Chip";

const FormulaDelete = (props) => {

    const { open, filter, paginationData, handleClose, isFormulaDeletePending, formulaDeleteErrorMessage, selectedFormulaDelete } = props;
    const { id, formulaName, isFormFieldFormula } = selectedFormulaDelete || {};
    useEffect(() => {
        props.formulaDeleteErrorClear();
    }, [open])

    const handleDelete = () => {
        if (id) {
            props.deleteFormula(id, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth={'xs'}
                fullWidth
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        '&>div': {
                            m: 0,
                            maxWidth: 470,
                            maxHeight: '100%'
                        }
                    }
                }}>
                {open && (
                    <>
                        <DialogContent>
                            {formulaDeleteErrorMessage && <ErrorAlert content={formulaDeleteErrorMessage} />}
                            <Grid container direction='column'>
                                <Grid item sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <IconTrash size={50} color="#CC2B52" />
                                </Grid>
                                <Grid item sx={{ display: "flex", justifyContent: "center", pt: 2, pb: 2 }}>
                                    {isFormFieldFormula ?
                                        <div>
                                            <Typography variant="h3">
                                                Are you sure you want to delete this formula?
                                            </Typography>
                                            <Typography variant="h4" sx={{ pb: 0.5, display: "flex", alignItems: "center", gap: "5px" }} color="#d94804">
                                                <IconAlertTriangle size={50} color="#d94804" /> Deleting this formula will also remove it from the form configuration list.
                                            </Typography>
                                        </div>
                                        :
                                        <Typography variant="h3">
                                            Are you sure you want to delete this formula ?
                                        </Typography>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                                <Tooltip title="Formula Name" placement="top">
                                    <Chip
                                        color="primary"
                                        label={formulaName}
                                        sx={{ fontWeight: "bold", fontSize: "14px", cursor: "pointer" }}
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid container justifyContent={"right"} gap={1} marginTop={2}>
                                <Button
                                    variant="contained"
                                    color='error'
                                    size="small"
                                    onClick={handleClose}
                                >
                                    No,cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                    onClick={handleDelete}
                                    disabled={isFormulaDeletePending}
                                >
                                    {isFormulaDeletePending ?
                                        <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <CircularProgress size={'20px'} color='inherit' />
                                            Loading...
                                        </Grid>
                                        : <>Yes, I&apos;m sure</>
                                    }
                                </Button>
                            </Grid>
                        </DialogContent>
                    </>
                )}
            </Dialog >
        </>
    )
}

const mapStateToProps = (state) => ({
    selectedFormulaDelete: state.formulae.selectedFormulaDelete,
    isFormulaDeletePending: state.formulae.isFormulaDeletePending,
    formulaDeleteErrorMessage: state.formulae.formulaDeleteErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    deleteFormula: (selectedFieldId, filter, paginationData) => dispatch(deleteFormula(selectedFieldId, filter, paginationData)),
    formulaDeleteErrorClear: () => dispatch(formulaDeleteErrorClear()),
})
export default connect(mapStateToProps, mapDispatchToProps)(FormulaDelete);